function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2551",
  "data-name": "Path 2551",
  d: "M1 1h14v14H1zM0 16h16V0H0z",
  fill: "#282828"
})));